module.exports = __webpack_public_path__ + "static/media/activity-mini-games.f157f039.png";